import { getArea } from 'ol/sphere';
import { readFeature } from '@abaco/map-web-module/src/modules/map-web-module/LayerBuilder';
import { PedologyGrouped, Survey } from '../../models/Pedology';

export interface PopupData {
    position: number[];
    items: Survey[];
    show: boolean;
}

export function AREA(val: number) {
    return (val / 10000).toFixed(2);
}

export function getAreaFromWkt(wkt: string, format = false) {
    const geometry = readFeature({ wkt: wkt }).getGeometry();
    if (geometry) {
        return format ? getArea(geometry) / 10000 : getArea(geometry);
    }
    return null
}

export function cloneObject<T>(obj: T, def?: any): T {
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        return def ? def : {};
    }
}

export function hashObject<T>(obj: T): string {
    try {
        return btoa(JSON.stringify(obj));
    } catch (error) {
        return btoa("");
    }
}

export function hashPedologyObject(item: PedologyGrouped | null | undefined): string {
    return hashObject({
        ladi_id: item?.ladi_id || "",
        theme_id: item?.theme_id || "",
    });
}
